import { render } from "./Primary.vue?vue&type=template&id=d8b3333e&scoped=true&ts=true"
import script from "./Primary.vue?vue&type=script&lang=ts"
export * from "./Primary.vue?vue&type=script&lang=ts"

import "./Primary.vue?vue&type=style&index=0&id=d8b3333e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b3333e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
